import React from 'react';
import HostIframe from './iframe/HostIframe';
import ModuleHost from './module/ModuleHost';
const ChaynsHost = _ref => {
  let {
    type,
    iFrameProps,
    functions,
    src,
    iFrameRef = undefined,
    loadingComponent = undefined,
    children = undefined,
    system,
    // shallow data
    pages,
    language,
    isAdminModeActive,
    site,
    user,
    currentPage,
    device,
    parameters,
    customData,
    environment,
    preventStagingReplacement,
    dialog
  } = _ref;
  switch (type) {
    case 'client-iframe':
      return /*#__PURE__*/React.createElement(HostIframe, {
        iFrameRef: iFrameRef,
        iFrameProps: iFrameProps,
        pages: pages,
        isAdminModeActive: isAdminModeActive,
        site: site,
        user: user,
        device: device,
        currentPage: currentPage,
        functions: functions,
        src: src,
        language: language,
        parameters: parameters,
        environment: environment,
        customData: customData,
        preventStagingReplacement: preventStagingReplacement,
        dialog: dialog
      });
    case 'client-module':
      return /*#__PURE__*/React.createElement(ModuleHost, {
        system: system,
        pages: pages,
        isAdminModeActive: isAdminModeActive,
        site: site,
        user: user,
        device: device,
        currentPage: currentPage,
        children: loadingComponent,
        functions: functions,
        language: language,
        parameters: parameters,
        customData: customData,
        environment: environment,
        preventStagingReplacement: preventStagingReplacement,
        dialog: dialog
      });
    case 'server-iframe':
      return /*#__PURE__*/React.createElement(HostIframe, {
        iFrameRef: iFrameRef,
        iFrameProps: iFrameProps,
        pages: pages,
        isAdminModeActive: isAdminModeActive,
        site: site,
        user: user,
        device: device,
        currentPage: currentPage,
        functions: functions,
        src: src,
        postForm: true,
        language: language,
        parameters: parameters,
        environment: environment,
        customData: customData,
        preventStagingReplacement: preventStagingReplacement,
        dialog: dialog
      });
    case 'server-module':
      return /*#__PURE__*/React.createElement(ModuleHost, {
        system: system,
        pages: pages,
        isAdminModeActive: isAdminModeActive,
        site: site,
        user: user,
        device: device,
        currentPage: currentPage,
        functions: functions,
        language: language,
        parameters: parameters,
        customData: customData,
        environment: environment,
        preventStagingReplacement: preventStagingReplacement,
        dialog: dialog
      }, children);
    default:
      return null;
  }
};
export default ChaynsHost;